import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { GA4_ID, CLARITY_ID, CONSENT_STORAGE_KEY } from '../config/analytics';

const CookieConsentContext = createContext(null);

const loadGA4 = (measurementId) => {
  if (!measurementId || document.getElementById('ga4-script')) return;

  const script = document.createElement('script');
  script.id = 'ga4-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', measurementId, { send_page_view: false });
};

const loadClarity = (projectId) => {
  if (!projectId || document.getElementById('clarity-script')) return;

  const script = document.createElement('script');
  script.id = 'clarity-script';
  script.type = 'text/javascript';
  script.innerHTML = `
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${projectId}");
  `;
  document.head.appendChild(script);
};

export const CookieConsentProvider = ({ children }) => {
  const [consent, setConsent] = useState(() => {
    const stored = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (stored === 'true') return true;
    if (stored === 'false') return false;
    return null;
  });

  const loadAnalytics = useCallback(() => {
    // Fejlesztői környezetben (localhost) ne menjen adat az éles GA4 / Clarity projektbe
    if (['localhost', '127.0.0.1'].includes(window.location.hostname)) return;
    loadGA4(GA4_ID);
    loadClarity(CLARITY_ID);
  }, []);

  useEffect(() => {
    if (consent === true) {
      loadAnalytics();
    }
  }, [consent, loadAnalytics]);

  const acceptCookies = useCallback(() => {
    localStorage.setItem(CONSENT_STORAGE_KEY, 'true');
    setConsent(true);
  }, []);

  const declineCookies = useCallback(() => {
    localStorage.setItem(CONSENT_STORAGE_KEY, 'false');
    setConsent(false);
  }, []);

  return (
    <CookieConsentContext.Provider value={{ consent, acceptCookies, declineCookies }}>
      {children}
    </CookieConsentContext.Provider>
  );
};

export const useCookieConsent = () => useContext(CookieConsentContext);
